module.exports = __webpack_public_path__ + "img/9@2x.5fe8f509.png";